import { Spin } from 'antd';

export default function LoadingSpin() {
  return (
    <div className="flex items-center justify-center">
      <Spin size="large" />
    </div>
  );
}


